// Paint size grid: totals, show/hide, multi-item add to cart
(function () {
  function formatMoney(cents) {
    var format = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat;
    if (format) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function isGridVisible(grid) {
    return grid && !grid.hidden && !grid.classList.contains('paint-size-grid--hidden');
  }

  function getPaintPrefixCount(variantPicker) {
    return parseInt(variantPicker.getAttribute('data-paint-prefix-count') || '2', 10);
  }

  function isGridReady(variantPicker) {
    var fieldsets = variantPicker.querySelectorAll('fieldset');
    var prefixCount = getPaintPrefixCount(variantPicker);
    if (prefixCount < 1) return false;

    for (var i = 0; i < prefixCount; i++) {
      if (!fieldsets[i] || !fieldsets[i].hasAttribute('data-field-valid')) {
        return false;
      }
    }
    return true;
  }

  function getProductForm(variantPicker) {
    var formId = variantPicker.getAttribute('form-id');
    return formId ? document.getElementById(formId) : null;
  }

  function getGridTotalQty(grid) {
    var totalQty = 0;
    grid.querySelectorAll('[data-paint-grid-qty-input]').forEach(function (input) {
      totalQty += parseInt(input.value, 10) || 0;
    });
    return totalQty;
  }

  function hideStandalonePriceBlock() {
    var priceBlock = document.querySelector('.product-info__block-item[data-block-type="price"]');
    if (priceBlock) priceBlock.style.display = 'none';
  }

  function getAddToCartButton(form) {
    var hStack = form.querySelector('buy-buttons .h-stack');
    if (!hStack) return null;

    var atcButton = hStack.querySelector(':scope > button.button:not(.paint-calculator-button)');
    if (atcButton) return atcButton;

    var buttons = hStack.querySelectorAll(':scope > button');
    return buttons.length ? buttons[buttons.length - 1] : null;
  }

  function neutralizeSingleVariantInputs(form) {
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.disabled = true;
      if (!idInput.dataset.paintGridNeutralized) {
        idInput.dataset.paintGridNeutralized = 'true';
        idInput.removeAttribute('name');
      }
    }

    var qtyInput = form.querySelector('buy-buttons input[name="quantity"]');
    if (qtyInput) {
      qtyInput.disabled = true;
      qtyInput.removeAttribute('name');
    }
  }

  function configurePaintGridAddToCartButton(atcButton) {
    atcButton.type = 'button';
  }

  function handlePaintGridAddToCartClick(event) {
    if (event.target.closest('.paint-calculator-button')) return;

    var variantPicker = document.querySelector('variant-picker[data-paint-grid-mode]');
    if (!variantPicker) return;

    var form = getProductForm(variantPicker);
    if (!form) return;

    var atcButton = getAddToCartButton(form);
    if (!atcButton || !atcButton.contains(event.target)) return;

    if (atcButton.disabled || atcButton.getAttribute('aria-busy') === 'true') return;

    var grid = variantPicker.querySelector('[data-paint-size-grid]');
    if (!isGridVisible(grid)) return;

    var items = getGridCartItems(grid);
    if (items.length === 0) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addGridItemsToCart(items, atcButton);
  }

  function updateAddToCartState(variantPicker) {
    var grid = variantPicker.querySelector('[data-paint-size-grid]');
    var form = getProductForm(variantPicker);
    if (!form) return;

    neutralizeSingleVariantInputs(form);

    var atcButton = getAddToCartButton(form);
    if (!atcButton) return;

    configurePaintGridAddToCartButton(atcButton);

    var ready = isGridReady(variantPicker);
    var totalQty = grid && isGridVisible(grid) ? getGridTotalQty(grid) : 0;
    var enable = ready && totalQty > 0;

    atcButton.disabled = !enable;
    atcButton.setAttribute('aria-disabled', enable ? 'false' : 'true');
    hideStandalonePriceBlock();
  }

  function syncFieldValidFromVariantChange(event) {
    var variantPicker = document.querySelector('variant-picker[data-paint-grid-mode]');
    if (!variantPicker) return;
    if (event.detail.formId && event.detail.formId !== variantPicker.getAttribute('form-id')) return;

    var optionsSoFar = event.detail.optionsSoFar || [];
    variantPicker.querySelectorAll('fieldset').forEach(function (fieldset, index) {
      if (optionsSoFar[index]) {
        fieldset.setAttribute('data-field-valid', optionsSoFar[index]);
      } else {
        fieldset.removeAttribute('data-field-valid');
      }
    });
  }

  function getPaintGridProductTitle(addResponse) {
    if (addResponse && addResponse.items && addResponse.items.length) {
      var title = addResponse.items[0].product_title || addResponse.items[0].title;
      if (title) return title;
    }

    var titleEl = document.querySelector(
      '.product-info__block-item[data-block-type="title"] h1, .product-info__block-item[data-block-type="title"] h2, .product-info h1'
    );
    return titleEl ? titleEl.textContent.trim() : 'Items';
  }

  function getAddedToCartMessage(productTitle) {
    if (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.addedToCart) {
      return window.themeVariables.strings.addedToCart.replace('{{product_title}}', productTitle);
    }
    return productTitle + ' added to your cart';
  }

  function formatCoverage(sqm) {
    var rounded = Math.round(sqm * 10) / 10;
    return rounded + ' m²';
  }

  function updateGridTotal(grid) {
    var totalPriceEl = grid.querySelector('[data-paint-size-total]');
    var totalCoverageEl = grid.querySelector('[data-paint-size-total-coverage]');
    var totalCoverageGroup = grid.querySelector('[data-paint-size-total-coverage-group]');

    var totalCents = 0;
    var totalCoverage = 0;
    var totalQty = 0;
    var allSelectedHaveCoverage = true;

    grid.querySelectorAll('.paint-size-grid__row[data-variant-id]').forEach(function (row) {
      var price = parseInt(row.getAttribute('data-price'), 10) || 0;
      var input = row.querySelector('[data-paint-grid-qty-input]');
      var qty = input ? parseInt(input.value, 10) || 0 : 0;

      totalCents += price * qty;
      totalQty += qty;

      if (qty <= 0) return;

      if (!row.hasAttribute('data-coverage')) {
        allSelectedHaveCoverage = false;
        return;
      }

      var coverage = parseFloat(row.getAttribute('data-coverage'));
      if (!coverage || coverage <= 0) {
        allSelectedHaveCoverage = false;
        return;
      }

      totalCoverage += coverage * qty;
    });

    if (totalPriceEl) totalPriceEl.innerHTML = formatMoney(totalCents);
    if (totalCoverageEl) totalCoverageEl.textContent = formatCoverage(totalCoverage);
    if (totalCoverageGroup) {
      var hideCoverage = totalQty === 0 || !allSelectedHaveCoverage;
      totalCoverageGroup.hidden = hideCoverage;
      totalCoverageGroup.toggleAttribute('aria-hidden', hideCoverage);
    }

    var variantPicker = grid.closest('variant-picker[data-paint-grid-mode]');
    if (variantPicker) updateAddToCartState(variantPicker);
  }

  function resetGridQuantities(grid) {
    grid.querySelectorAll('[data-paint-grid-qty-input]').forEach(function (input) {
      input.value = 0;
    });
    grid.querySelectorAll('quantity-selector[data-paint-grid-qty]').forEach(function (qs) {
      var minusBtn = qs.querySelector('button:first-of-type');
      if (minusBtn) minusBtn.disabled = true;
    });
    updateGridTotal(grid);
  }

  function updateGridVisibility(variantPicker) {
    var grid = variantPicker.querySelector('[data-paint-size-grid]');
    var placeholder = variantPicker.querySelector('[data-paint-size-placeholder]');
    if (!grid) return;

    var wasHidden = grid.hidden;
    var ready = isGridReady(variantPicker);

    grid.hidden = !ready;
    grid.classList.toggle('paint-size-grid--hidden', !ready);

    if (placeholder) {
      placeholder.hidden = ready;
      placeholder.classList.toggle('paint-size-grid__placeholder--hidden', ready);
    }

    if (!ready || wasHidden) {
      resetGridQuantities(grid);
    } else {
      updateAddToCartState(variantPicker);
    }
  }

  function initPaintSizeGridSystem() {
    document.querySelectorAll('variant-picker[data-paint-grid-mode]').forEach(function (variantPicker) {
      updateGridVisibility(variantPicker);
    });
  }

  function getGridCartItems(grid) {
    var items = [];
    grid.querySelectorAll('.paint-size-grid__row[data-variant-id]').forEach(function (row) {
      var input = row.querySelector('[data-paint-grid-qty-input]');
      if (!input) return;

      var qty = parseInt(input.value, 10) || 0;
      if (input.hasAttribute('max')) {
        var maxQty = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(maxQty) && qty > maxQty) {
          qty = maxQty;
          input.value = maxQty;
        }
      }

      if (qty > 0) {
        items.push({
          id: parseInt(row.getAttribute('data-variant-id'), 10),
          quantity: qty
        });
      }
    });
    return items;
  }

  function getCartDrawerSectionIds() {
    var sectionIds = new Set();
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionIds }
    }));

    if (sectionIds.size > 0) {
      return Array.from(sectionIds);
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var el = cartDrawer;
    while (el && el !== document.body) {
      if (el.id && el.id.indexOf('__cart-drawer') !== -1) {
        return [el.id.replace(/^shopify-section-/, '')];
      }
      el = el.parentElement;
    }

    return [];
  }

  function fetchCartWithSections(sectionIds) {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cartData) {
        if (!sectionIds.length) return cartData;

        return fetch(window.Shopify.routes.root + '?sections=' + sectionIds.join(','))
          .then(function (response) { return response.json(); })
          .then(function (sectionsData) {
            cartData.sections = sectionsData;
            return cartData;
          })
          .catch(function () {
            return cartData;
          });
      });
  }

  function addGridItemsToCart(items, submitButton) {
    if (submitButton) {
      submitButton.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
    }

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var addResponse;

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || err.message || 'Network error');
          });
        }
        return response.json();
      })
      .then(function (responseData) {
        addResponse = responseData;
        return fetchCartWithSections(getCartDrawerSectionIds());
      })
      .then(function (cartData) {
        var variantPicker = document.querySelector('variant-picker[data-paint-grid-mode]');
        var form = variantPicker ? getProductForm(variantPicker) : null;
        var cartType = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType;
        var redirectToCart = cartType === 'page' ||
          (window.themeVariables.settings.pageType === 'cart');

        if (form) {
          form.dispatchEvent(new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: (addResponse && addResponse.items) ? addResponse.items : items,
              cart: cartData
            }
          }));
        }

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cartData
          }
        }));

        if (window.themeVariables && window.themeVariables.settings) {
          if (redirectToCart) {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }
          if (cartType === 'message') {
            document.dispatchEvent(new CustomEvent('toast:show', {
              detail: {
                message: getAddedToCartMessage(getPaintGridProductTitle(addResponse))
              }
            }));
          }
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.show();
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }

        if (!redirectToCart && variantPicker) {
          var grid = variantPicker.querySelector('[data-paint-size-grid]');
          if (grid) resetGridQuantities(grid);
        }
      })
      .catch(function (error) {
        console.error('Paint grid add to cart error:', error);
        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: {
            message: error.message || 'There was a problem adding items to your cart. Please try again.',
            tone: 'error'
          }
        }));
      })
      .finally(function () {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        if (submitButton) {
          submitButton.removeAttribute('aria-busy');
        }
        var variantPicker = document.querySelector('variant-picker[data-paint-grid-mode]');
        if (variantPicker) updateAddToCartState(variantPicker);
      });
  }

  document.addEventListener('click', handlePaintGridAddToCartClick, true);

  // Safety net if a type="submit" slips through after AJAX rerender.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    var variantPicker = document.querySelector('variant-picker[data-paint-grid-mode]');
    if (!variantPicker || variantPicker.getAttribute('form-id') !== form.id) return;

    var grid = variantPicker.querySelector('[data-paint-size-grid]');
    if (!isGridVisible(grid)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var items = getGridCartItems(grid);
    if (items.length === 0) return;

    var button = getAddToCartButton(form);
    addGridItemsToCart(items, button);
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-paint-grid-qty-input]')) return;
    var grid = event.target.closest('[data-paint-size-grid]');
    if (grid) updateGridTotal(grid);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-paint-grid-qty-input]')) return;
    var grid = event.target.closest('[data-paint-size-grid]');
    if (grid) updateGridTotal(grid);
  });

  document.addEventListener('DOMContentLoaded', function () {
    requestAnimationFrame(function () {
      initPaintSizeGridSystem();
    });
  });

  document.addEventListener('variant:change', function (event) {
    syncFieldValidFromVariantChange(event);
    requestAnimationFrame(function () {
      initPaintSizeGridSystem();
    });
  });

  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(function () {
      initPaintSizeGridSystem();
    });
  }, true);
})();
